/**
 * Functions that helps the URL
 *
 * @packageDocumentation
 */

/**
 * Get the `target` property for a link, based on the target URL
 */
export const getHrefTarget = (input: string): string => {
    let url: URL

    try {
        url = new URL(input)
    } catch (_) {
        return ''
    }

    if (url.hostname !== window.location.hostname) {
        return 'target="_blank" rel="noopener"'
    }
    return ''
}
